import { I18n } from "@/i18n/I18n";
import { INSTRUMENT_CATEGORY } from "@/types/equipmentTypes";
import { Dropdown, Form } from "react-bootstrap";

export const categoryDropdownString = (category?: INSTRUMENT_CATEGORY) => {
  if (!category) {
    return I18n.get('noCategory');
  }

  switch (category) {
    case INSTRUMENT_CATEGORY.POWER_SUPPLY:
      return I18n.get('powerSupply');
    case INSTRUMENT_CATEGORY.MULTIMETER:
      return I18n.get('multimeter');
    case INSTRUMENT_CATEGORY.OSCILLOSCOPE:
      return I18n.get('oscilloscope');
    case INSTRUMENT_CATEGORY.FUNCTION_GENERATOR:
      return I18n.get('functionGenerator');
    case INSTRUMENT_CATEGORY.LOGIC_ANALYZER:
      return I18n.get('logicAnalyzer');
    case INSTRUMENT_CATEGORY.DIGITAL_MULTIMETER:
      return I18n.get('digitalMultimeter');
    case INSTRUMENT_CATEGORY.DIGITAL_FUNCTION_GENERATOR:
      return I18n.get('digitalFunctionGenerator');
    case INSTRUMENT_CATEGORY.DAQ:
      return I18n.get('dataAcquisition');
    default:
      return I18n.get('noCategory');
  }
};

interface InstrumentCategoryDropdownProps {
  category?: INSTRUMENT_CATEGORY;
  onChange: (name: string, value: string) => void;
  disabled?: boolean;
}

export function InstrumentCategoryDropdown({ category, onChange, disabled = false }: InstrumentCategoryDropdownProps) {
  return (
    <div className='w-100 pl-1'>
      <Form.Label className="col-form-label">{I18n.get('category')}</Form.Label>
      <Dropdown>
        <Dropdown.Toggle
          variant="outline-secondary"
          id="instrument-category-dropdown"
          className='d-flex align-items-center justify-content-between w-100'
          style={{ opacity: disabled ? '0.5' : '0.7' }}
          disabled={disabled}
        >
          <p className='mb-0'>{categoryDropdownString(category)}</p>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Header>{I18n.get('selectCategory')}</Dropdown.Header>
          <Dropdown.Item
            onClick={() => onChange('category', INSTRUMENT_CATEGORY.NONE)}
          >
            {I18n.get('noCategory')}
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => onChange('category', INSTRUMENT_CATEGORY.POWER_SUPPLY)}
          >
            {I18n.get('powerSupply')}
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => onChange('category', INSTRUMENT_CATEGORY.MULTIMETER)}
          >
            {I18n.get('multimeter')}
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => onChange('category', INSTRUMENT_CATEGORY.OSCILLOSCOPE)}
          >
            {I18n.get('oscilloscope')}
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => onChange('category', INSTRUMENT_CATEGORY.FUNCTION_GENERATOR)}
          >
            {I18n.get('functionGenerator')}
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => onChange('category', INSTRUMENT_CATEGORY.LOGIC_ANALYZER)}
          >
            {I18n.get('logicAnalyzer')}
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => onChange('category', INSTRUMENT_CATEGORY.DIGITAL_MULTIMETER)}
          >
            {I18n.get('digitalMultimeter')}
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => onChange('category', INSTRUMENT_CATEGORY.DIGITAL_FUNCTION_GENERATOR)}
          >
            {I18n.get('digitalFunctionGenerator')}
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => onChange('category', INSTRUMENT_CATEGORY.DAQ)}
          >
            {I18n.get('dataAcquisition')}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
